import { Button } from "@mui/material";
import { LockIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { useSignOut } from "Auth/Hooks/useSignOut";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const ErrorAppAccessPage: React.FunctionComponent = (_) => {
  const { t } = useResource();

  const signOut = useSignOut();

  return (
    <UnauthenticatedLayout title={t(Resources.Errors.ErrorAppAccess.Title)}>
      <EmptyPage
        icon={<LockIcon />}
        title={t(Resources.Errors.ErrorAppAccess.Title)}
        subtitle={t(Resources.Errors.ErrorAppAccess.Subtitle)}
        actions={
          <Button variant="contained" onClick={() => signOut()}>
            {t(Resources.Errors.ErrorAppAccess.Button)}
          </Button>
        }
      />
    </UnauthenticatedLayout>
  );
};
